import { useWSQuery, WSQueryConfig } from "@ws-react-query";
import { WSServiceError } from "../../utils/serviceHelper";
import { getPlanEnrollment } from "../../services/api/planEnrollment/getPlanEnrollment";
import { IPlanEnrollment } from "../../services/api/planEnrollment/types";

export const QUERY_BENEFITS_PLAN_ENROLLMENT = "QUERY_BENEFITS_PLAN_ENROLLMENT";

export const usePlanEnrollment = (
  planEnrollmentId: string,
  config?: WSQueryConfig<IPlanEnrollment, WSServiceError>
) =>
  useWSQuery(
    [QUERY_BENEFITS_PLAN_ENROLLMENT, planEnrollmentId],
    () => getPlanEnrollment(planEnrollmentId),
    config
  );
